export default __webpack_public_path__ + "static/media/ltr_online_education.a2abf14d.png";